import React, { useState } from "react";
import "../../style/Body/Compartir.css";
import { BsShare, BsClipboard, BsTelephone } from "react-icons/bs";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import { useAppContext } from "../../AppContext";
import CustomModal from '../styleComponents/CustomModal';

export default function Compartir() {

  const { globalState } = useAppContext({});

  const [isModified, setIsModified] = useState(false);
  const [phoneNum, setPhoneNum] = useState("");
  const [link] = useState(process.env.REACT_APP_URL_WEB+"/"+globalState.studyId+"?p="+btoa(JSON.stringify({"r":globalState.shortUuid}))+globalState.urlUtms);
  
  const [open, setOpen] = useState(false);
  const onCloseModal = () => setOpen(false);
  const [mensajeModal, setMensajeModal] = useState("");


  const handleChange = (event) => {
    const inputPhoneNumber = event.target.value;

    if (inputPhoneNumber.length < 11){
      setIsModified(true);
      setPhoneNum(inputPhoneNumber);  
    }
  };
  const handleCopy = () => {
    setMensajeModal("Copiado en portapapeles");
    setOpen(true);
  }
  const handlerSendWhats = () => {
    if (isValidPhoneNumber && isModified){
      window.open("https://wa.me/"+phoneNum+"?text="+encodeURIComponent(link), "_blank");
    } else {
      setMensajeModal("El número no es válido");
      setOpen(true);
    }
  }
  const isValidPhoneNumber =
  phoneNum.length === 10 && /^\d+$/.test(phoneNum);

  return (
    <>
        <CustomModal isOpenModal={open} onClose={onCloseModal} title={'¡Aviso!'}>
                <h2 className="text-white">{mensajeModal}</h2>
            </CustomModal>
      <div className="recuadro-compartir ">
        <h2 className="title-compartir">Comparte este contenido</h2>
        <p className="subtitle-compartir">
          Compartir con un amigo a través de un link o un número celular.
        </p>
        <p className="text-compartir">Compartir con un amigo:</p>

        <div className="input-container-compartir">
          <div className="divider-compartir">
            <span className="input-icon-compartir">
              <BsShare  />
            </span>
            <input
              disabled
              type="text"
              className="input-compartir"
              placeholder="Link"
              value={link}
            />
          </div>
          <CopyToClipboard onCopy={handleCopy} text={link}>

          <button className="button-compartir">

            <BsClipboard />

          </button>
          </CopyToClipboard>

        </div>
        <p className="text-compartir">Enviar a un número de WhatsApp:</p>

        <div className="input-container-celular-compartir">
          <div
            className={`divider-celular-compartir ${
              isModified && (isValidPhoneNumber ? "valid" : "invalid")
            }`}
          >
            <span className={`input-icon-celular-compartir ${
              isModified && (isValidPhoneNumber ? "valid" : "invalid")
            }`}>
              <BsTelephone />
            </span>
            <input
              type="number"
              className="input-celular-compartir"
              placeholder="Número celular"
              onChange={handleChange}
              value={phoneNum}
            />
          </div>
          <button className="invite-button" onClick={handlerSendWhats}>Invitar</button>
        </div>
      </div>
    </>
  );
}
